import { ADD_TO_CART, REMOVE_FROM_CART } from "../Actions/actions";

const initialState = {
  inventory: [
    {
      id: 1,
      title: "Item 1",
      description: "A great lamp",
      cost: 10.01,
      url:
        "https://res.cloudinary.com/dream-flowers-llc/image/upload/v1578958572/20180823_141941.jpg",
      quantity: 0
    },
    {
      id: 2,
      title: "Item 1 is an amazing light",
      description: "A great lamp that is strong and bright and g",
      cost: 10.01,
      quantity: 0
    },
    {
      id: 3,
      title: "Item 1",
      description: "A great lamp",
      cost: 10.01,
      quantity: 0
    },
    {
      id: 4,
      title: "Item 1",
      description: "A great lamp",
      cost: 10.01,
      quantity: 0
    },
    {
      id: 5,
      title: "Item 1",
      description: "A great lamp",
      cost: 10.01,
      quantity: 0
    },
    {
      id: 6,
      title: "Item 1",
      description: "A great lamp",
      cost: 10.01,
      quantity: 0
    },
    {
      id: 7,
      title: "Item 1",
      description: "A great lamp",
      cost: 10.01,
      quantity: 0
    },
    {
      id: 8,
      title: "Item 1",
      description: "A great lamp",
      cost: 10.01,
      quantity: 0
    },
    {
      id: 9,
      title: "Item 1",
      description: "A great lamp",
      cost: 10.01,
      quantity: 0
    },
    {
      id: 10,
      title: "Item 1",
      description: "A great lamp",
      cost: 10.01,
      quantity: 0
    },
    {
      id: 11,
      title: "Item 1",
      description: "A great lamp",
      cost: 10.01,
      quantity: 0
    },
    {
      id: 12,
      title: "Item 1",
      description: "A great lamp",
      cost: 10.01,
      quantity: 0
    },
    {
      id: 13,
      title: "Item 1",
      description: "A great lamp",
      cost: 10.01,
      quantity: 0
    },
    {
      id: 14,
      title: "Item 1",
      description: "A great lamp",
      cost: 10.01,
      quantity: 0
    },
    {
      id: 15,
      title: "Item 1",
      description: "A great lamp",
      cost: 10.01,
      quantity: 0
    },
    {
      id: 16,
      title: "Item 1",
      description: "A great lamp",
      cost: 10.01,
      quantity: 0
    },
    {
      id: 17,
      title: "Item 1",
      description: "A great lamp",
      cost: 10.01,
      quantity: 0
    },
    {
      id: 18,
      title: "Item 1",
      description: "A great lamp",
      cost: 10.01,
      quantity: 0
    },
    {
      id: 19,
      title: "Item 1",
      description: "A great lamp",
      cost: 10.01,
      quantity: 0
    }
  ],
  addedItems: [],
  total: 0
};

export default function CartReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_TO_CART: {
      let addedItem = state.inventory.find(item => item.id === action.id);
      let existed_item = state.addedItems.find(item => action.id === item.id);
      if (existed_item) {
        addedItem.quantity += 1;
        return {
          ...state,
          total: state.total + addedItem.cost
        };
      } else {
        addedItem.quantity = 1;
        let newTotal = state.total + addedItem.cost;
        return {
          ...state,
          addedItems: [...state.addedItems, addedItem],
          total: newTotal
        };
      }
    }
    case REMOVE_FROM_CART: {
      let addedItem = state.inventory.find(item => item.id === action.id);
      if (addedItem.quantity === 1) {
        let new_items = state.addedItems.filter(item => item.id !== action.id);
        let newTotal = state.total - addedItem.cost;
        return {
          ...state,
          addedItems: new_items,
          total: newTotal
        };
      } else {
        addedItem.quantity -= 1;
        let newTotal = state.total - addedItem.cost;
        return {
          ...state,
          total: newTotal
        };
      }
    }
    default:
      return state;
  }
}
